import { createFileRoute } from "@tanstack/react-router";

import { Section } from "@roqua/components/sections";

import { ErrorPage } from "@/components/ErrorPage";
import { RemovalForm } from "@/components/SelfRegistrations/RemovalForm";
import { useVerifiedSession } from "@/session";
import { toError } from "@/lib/utils";

export const Route = createFileRoute("/portal/self_registration")({
  component: RouteComponent,
  errorComponent: ({ error }) => <ErrorPage message={toError(error).message} />,
});

function RouteComponent() {
  const { dossierId } = useVerifiedSession();

  return (
    <Section variant="content">
      <div>
        <RemovalForm dossierId={dossierId} />
      </div>
    </Section>
  );
}
